/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IEscrowUpdateBeneficiaryNotificationsMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  escrowParams: Types.IEscrowUpdateBeneficiaryNotificationsParams;
}>;

export type IEscrowUpdateBeneficiaryNotificationsMutation = {
  __typename?: 'Mutation';
  escrowUpdateBeneficiaryNotifications?: {
    __typename?: 'EscrowUpdateBeneficiaryNotificationsPayload';
    success: boolean;
    errors?: Array<string> | null;
    escrow:
      | {
          __typename?: 'ContinuityEscrow';
          id: string;
          beneficiaryActivityNotification: Types.ActivityNotificationEnum;
          beneficiaryDisruptionNotification: Types.DisruptionNotificationEnum;
          beneficiaryDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
        }
      | {
          __typename?: 'SaasEscrow';
          id: string;
          beneficiaryActivityNotification: Types.ActivityNotificationEnum;
          beneficiaryDisruptionNotification: Types.DisruptionNotificationEnum;
          beneficiaryDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          beneficiaryActivityNotification: Types.ActivityNotificationEnum;
          beneficiaryDisruptionNotification: Types.DisruptionNotificationEnum;
          beneficiaryDisruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
        };
  } | null;
};

export const EscrowUpdateBeneficiaryNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'escrowUpdateBeneficiaryNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowUpdateBeneficiaryNotificationsParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowUpdateBeneficiaryNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryActivityNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryDisruptionNotification' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryDisruptionNotificationGracePeriod' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IEscrowUpdateBeneficiaryNotificationsMutation,
  IEscrowUpdateBeneficiaryNotificationsMutationVariables
>;
